import "../../FhLink.css";
import { useSlots, inject, computed, onMounted, openBlock, createBlock, resolveDynamicComponent, normalizeClass, withCtx, createCommentVNode, renderSlot, unref } from "vue";
import { isExternalURL } from "../../utils/url.mjs";
import { VARIANTS_ENUMS, SIZES_ENUMS } from "./constants.mjs";
import externalLink from "../../icons/externalLink.mjs";
import FhIcon from "../FhIcon/FhIcon.mjs";
import { BODY_VARIANTS } from "../FhText/constants.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {
  __name: "FhLink",
  props: {
    variant: {
      type: String,
      default: VARIANTS_ENUMS.PRIMARY,
      validator: (value) => Object.values(VARIANTS_ENUMS).includes(value)
    },
    size: {
      type: String,
      default: "",
      validator: (value) => value === "" || Object.values(SIZES_ENUMS).includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    standalone: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const textVariant = inject("textVariant", void 0);
    const computedLinkSize = computed(() => {
      if (props.size) {
        return props.size;
      }
      const sizeMap = {
        [BODY_VARIANTS.BODY_SM]: SIZES_ENUMS.SM,
        [BODY_VARIANTS.BODY_MD]: SIZES_ENUMS.MD,
        [BODY_VARIANTS.BODY_LG]: SIZES_ENUMS.LG
      };
      return sizeMap[textVariant] || SIZES_ENUMS.MD;
    });
    const computedIconSize = computed(() => {
      return computedLinkSize.value === SIZES_ENUMS.SM || computedLinkSize.value === SIZES_ENUMS.MD ? "sm" : "md";
    });
    const computedLinkClasses = computed(() => {
      return [
        "fh-link",
        `fh-link--${props.variant}`,
        `fh-link--${computedLinkSize.value}`,
        textVariant && "fh-link--text-variant",
        props.standalone && "fh-link--standalone"
      ];
    });
    const computedDisabled = computed(() => {
      return props.disabled ? props.disabled : void 0;
    });
    const tag = computed(() => props.href ? "a" : "button");
    const type = computed(() => tag.value === "button" ? "button" : null);
    const href = computed(
      () => !props.disabled && props.href ? props.href : null
    );
    const isExternalLink = computed(() => isExternalURL(props.href));
    const linkTarget = computed(() => isExternalLink.value ? "_blank" : null);
    const linkRel = computed(() => isExternalLink.value ? "noreferrer" : null);
    onMounted(() => {
      if (!slots.default || slots.default().length === 0) {
        console.warn("FhLink component requires default slot content.");
      }
    });
    return (_ctx, _cache) => {
      return _ctx.$slots.default ? (openBlock(), createBlock(resolveDynamicComponent(tag.value), {
        key: 0,
        type: type.value,
        href: href.value,
        target: linkTarget.value,
        class: normalizeClass(computedLinkClasses.value),
        rel: linkRel.value,
        "aria-disabled": computedDisabled.value,
        size: computedLinkSize.value
      }, {
        default: withCtx(() => [
          props.icon ? (openBlock(), createBlock(FhIcon, {
            key: 0,
            size: computedIconSize.value,
            icon: props.icon,
            class: "fh-icon--prefix"
          }, null, 8, ["size", "icon"])) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "default", {}, void 0, true),
          isExternalLink.value ? (openBlock(), createBlock(FhIcon, {
            key: 1,
            size: computedIconSize.value,
            icon: unref(externalLink),
            class: "fh-icon--external"
          }, null, 8, ["size", "icon"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["type", "href", "target", "class", "rel", "aria-disabled", "size"])) : createCommentVNode("", true);
    };
  }
};
const FhLink = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-c8b98fee"]]);
export {
  FhLink as default
};
//# sourceMappingURL=FhLink.mjs.map
